import { Property } from '@propertypal/shared/src/types/property';
import platform from '@propertypal/shared/src/utils/platform';
import { camelCase } from '@propertypal/shared/src/utils/text';
import React, { FunctionComponent } from 'react';
import { BannerText, Container } from './PropertyBanner.style';

interface Props {
  property: Property;
  highlighted?: boolean;
}

const BANNER_TYPES = ['saleAgreed', 'letAgreed', 'sold', 'let', 'underOffer'];

const PropertyBanner: FunctionComponent<Props> = (props) => {
  const developmentStatus = props.property.developmentStatus || props.property.development?.developmentStatus;

  if (props.highlighted) {
    return (
      <Container $type="pinned">
        <BannerText style={{ fontSize: 12 }}>HIGHLIGHTED DEVELOPMENT</BannerText>
      </Container>
    );
  }

  if (props.property.comingSoonText) {
    const fontSize = props.property.comingSoonText.length > 20 ? 12 : 14;

    return (
      <Container $type={camelCase(props.property.comingSoonText)}>
        <BannerText data-testid="developmentText" style={{ fontSize }}>
          {props.property.comingSoonText.toUpperCase()}
        </BannerText>
      </Container>
    );
  }

  if (props.property.status && BANNER_TYPES.includes(props.property.status.key)) {
    return (
      <Container $type="status">
        <BannerText data-testid="bannerText">{props.property.status.text.toUpperCase()}</BannerText>
      </Container>
    );
  }

  if (developmentStatus && developmentStatus.key !== 'available') {
    const fontSize = developmentStatus.text.length > 20 ? 12 : 14;

    return (
      <Container $type={developmentStatus.key}>
        <BannerText data-testid="developmentText" style={{ fontSize }}>
          {developmentStatus.text.toUpperCase()}
        </BannerText>
      </Container>
    );
  }

  if (props.property.featuredListing && developmentStatus) {
    return (
      <Container $type="featured">
        <BannerText data-testid="featuredText">FEATURED DEVELOPMENT</BannerText>
      </Container>
    );
  }

  if (props.property.featuredListing && platform.type === 'propertynews') {
    return (
      <Container $type="featured">
        <BannerText data-testid="featuredText">FEATURED</BannerText>
      </Container>
    );
  }

  return null;
};

export default PropertyBanner;
